// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateNewPage_container__1-brD","loaderContainer":"CreateNewPage_loaderContainer__2VsV4"};